/*
Grommets

  --liner <bool> | checkbox
*/

import {
  name,
  manufacturer,
  manufacturerNumber,
  computerEaseNumber,
  color
} from '@/modules/standardItems/schemas/baseFormFields'

export default [
  name(),
  manufacturer(),
  manufacturerNumber(),
  computerEaseNumber(),
  color({ classes: ['xs12'] }),
  {
    key: 'liner',
    value: 'liner',
    type: 'checkbox',
    default: false,
    classes: ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
    attributes: {
      label: 'Liner',
      class: ['input--dense']
    }
  }
]
